const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// 将 PUB_SUB_EVENTS 附加到 window 对象，使其全局可用
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
